var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Wizard',{staticClass:"wizard",attrs:{"icon":"mdi-alert"}},[_c('div',{staticClass:"text-h5"},[_vm._v(" Unable to play media. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }